












































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';
import { QuillEditor, IntroItem } from '@/common/interface';
import { replaceString } from '@/common/utils/dealWithString';
import { isMobile } from '@/common/utils/getPlaform';
import { getInputStyle } from '@/common/utils/getStyles';
import { majorNoticeText } from '@/common/constants/index';

import getUrlParam from '@/common/utils/getUrlParam';
import FieldButton from '@/components/common/edit/FieldButton.vue';
import ActivityLabel from '@/components/common/edit/ActivityLabel.vue';
import ImageUpload from '@/components/common/edit/ImageUpload.vue';
import CourseIntroList from './CourseIntroList.vue';
import fetch from '@/common/api/fetch';
const IconVideo = 'https://image.xiaomaiketang.com/xm/rfxJ5Yidac.png';
const IconImg = 'https://xiaomai-image.oss-cn-hangzhou.aliyuncs.com/1571311697436.png?x-oss-process=image/resize,w_300,limit_0';
const FieldText = 'https://xiaomai-image.oss-cn-hangzhou.aliyuncs.com/1571311714121.png?x-oss-process=image/resize,w_300,limit_0';
interface Payload {
  item: IntroItem;
  seqNo: number;
}

@Component({
  components: {
    'activity-label': ActivityLabel,
    'field-button': FieldButton,
    'course-intro-list': CourseIntroList,
    'image-upload': ImageUpload
  }
})
export default class CourseGroupDesc extends Vue {
  @Prop() seqNo: any;
  @Prop() courseIntros: any;

  @Getter('section') section: any;
  @Getter('orgId') orgId!: string;
  @Getter('xcxType') xcxType!: string;
  @Getter('xcxFlag') xcxFlag!: boolean;
  @Getter('xmMajordomo') xmMajordomo!: boolean;
  @Getter('sectioncourseIntrosTextNum') sectioncourseIntrosTextNum!: number;
  @Getter('sectionCourseIntrosImgNum') sectionCourseIntrosImgNum!: number;

  @Action('addSectionCourseGroupIntros') addSectionCourseGroupIntros!: Function;
  @Action('changeShowFooter') changeShowFooter!: Function;
  @Action('downSectionCourseGroupIntros') downSectionCourseGroupIntros!: Function;
  @Action('changeSectionCourseGroupIntros') changeSectionCourseGroupIntros!: Function;
  @Action('deleteSectionCourseGroupIntros') deleteSectionCourseGroupIntros!: Function;
  @Action('upSectionCourseGroupIntros') upSectionCourseGroupIntros!: Function;

  isMobile: Function = isMobile;
  replaceString: Function = replaceString;
  IconImg: string = IconImg;
  FieldText: string = FieldText;
  IconVideo: string = IconVideo;
  showTitleModal: boolean = false;
  videoList: any = [];
  showVideo: Boolean = false;
  selectItem: any = {};
  type: string = getUrlParam('type') as string;

  // get inputStyle() {
  //   console.log(this.courseIntros,'123');
  //   const { inputFontColor, inputBackgroundColor } = this.section;
  //   return getInputStyle(inputFontColor, inputBackgroundColor);
  // }

  get courseIntrosList() {
    return this.courseIntros || [];
  }

  get inputStyle() {
    const { inputFontColor, inputBackgroundColor } = this.section;
    return getInputStyle(inputFontColor, inputBackgroundColor);
  }

  onEditorChange(event: QuillEditor, index: number) {
    // 限制1000个字符
    if (event.quill.getLength() - 1 > 1000) {
      event.quill.deleteText(1000, 1);
      return;
    }
    this.changeSectionCourseGroupIntros({
      index,
      value: event.html,
      seqNo: this.seqNo
    });
  }
  // 添加文本
  handleAddTextIntro(): void {
    console.log(this.courseIntrosList, 'courseIntrosList');
    if (this.courseIntrosList.length < 10) {
      const introItem: IntroItem = {
        type: 'text',
        value: ''
      };
      const payload: Payload = {
        item: introItem,
        seqNo: this.seqNo
      };
      this.addSectionCourseGroupIntros(payload);
    } else {
      Vue.$toast.info('最多添加10个文本');
    }
  }

  handleAddImage(imgUrl: string): void {
    if (this.sectionCourseIntrosImgNum < 10) {
      const filedImgs = document.getElementsByClassName('field-img-upload');
      Array.from(filedImgs).forEach((img: any) => {
        img.value = '';
      });
      const introItem: IntroItem = {
        type: 'img',
        value: imgUrl
      };
      const payload: Payload = {
        item: introItem,
        seqNo: this.seqNo
      };
      this.addSectionCourseGroupIntros(payload);
    } else {
      Vue.$toast.info('最多添加10个图片');
    }
  }
  handleShowVideo(): void {
    if (this.xcxType === 'mkb') {
      return;
    }
    if (this.xcxFlag && !this.xmMajordomo) {
      Vue.$confirm({
        oneBtn: true,
        title: '提示',
        text: majorNoticeText,
        okText: '确定'
      });
      return;
    }
    this.getVideoList();
    this.showVideo = true;
    this.changeShowFooter(false);
  }
  handleCloseVideo(): void {
    this.selectItem = {};
    this.showVideo = false;
    this.changeShowFooter(true);
  }

  selectVideo(): void {
    if (this.selectItem.videoUrl) {
      const introItem: IntroItem = {
        type: 'video',
        value: this.selectItem.videoUrl,
        coverUrl: this.selectItem.coverUrl
      };
      const payload: Payload = {
        item: introItem,
        seqNo: this.seqNo
      };
      this.showVideo = false;
      this.addSectionCourseGroupIntros(payload);
      this.changeShowFooter(true);
    }
  }
  handleToggleSelectItem(item: object): void {
    if (this.selectItem === item) {
      this.selectItem = {};
    } else {
      this.selectItem = item;
    }
  }
  getVideoList() {
    const instId = getUrlParam('instId');
    const activityId = getUrlParam('broadcastId');
    if (instId) {
      return fetch.Sales('anon/businessShow/getCustomizeVideoList', { instId }).then((res: any) => {
        this.videoList = res.result || [];
        this.videoList.map((item: any) => {
          item.bag = item.coverUrl || item.videoUrl + '?x-oss-process=video/snapshot,t_1,m_fast';
        });
        (this.section.prizeIntros || []).map((item: any) => {
          if (item.type == 'video') {
            this.selectItem = {
              videoUrl: item.value,
              coverUrl: item.coverUrl
            };
          }
        });
      });
    } else {
      return fetch.Sales('anon/businessShow/getCustomizeVideoList', { activityId }).then((res: any) => {
        this.videoList = res.result || [];
        this.videoList.map((item: any) => {
          item.bag = item.coverUrl || item.videoUrl + '?x-oss-process=video/snapshot,t_1,m_fast';
        });
        (this.section.prizeIntros || []).map((item: any) => {
          if (item.type == 'video') {
            this.selectItem = {
              videoUrl: item.value,
              coverUrl: item.coverUrl
            };
          }
        });
      });
    }
  }
  // 替换图片
  handleReplaceImg(imgUrl: string, index: number) {
    this.changeSectionCourseGroupIntros({ index, value: imgUrl, seqNo: this.seqNo });
  }
  // 上移项目
  handleUpItem(index: number) {
    const payload = {
      index,
      seqNo: this.seqNo
    };
    this.upSectionCourseGroupIntros(payload);
  }
  // 下移项目
  handleDownItem(index: number) {
    const payload = {
      index,
      seqNo: this.seqNo
    };
    this.downSectionCourseGroupIntros(payload);
  }
  // 删除项目
  handleDeleteIntroItem(index: number): void {
    Vue.$confirm({
      text: '确定删除吗',
      ok: () => {
        const payload = {
          index,
          seqNo: this.seqNo
        };
        this.deleteSectionCourseGroupIntros(payload);
        Vue.$toast.success('删除成功！');
      }
    });
  }
  handleVideo(item: any) {
    if (this.type === 'edit') {
      return;
    }
    fetch.parseUrl(item.value).then((res: any) => {
      const query = {
        url: res || item.value
      };
      this.$router.push({
        name: 'video',
        query: query
      });
    });
  }
}
